import React from 'react'
import styles from './Materials.module.css'
import {
  MaterialsImg1,
  MaterialsImg2,
  MaterialsImg3,
  MaterialsImg4,
} from '../../../Assets/Images/WindowsPage/Materials/Index'

const cards = [
  {
    img: MaterialsImg1,
    title: "PVCu Profile",
    text: "A multi-chamber structure designed for superior insulation and stability. Resistant to moisture and deformation, it requires no additional maintenance."
  },
  {
    img: MaterialsImg2,
    title: "Aluminium Frame",
    text: "Ensures rigidity, lightness and a refined appearance while maintaining optimal structural support."
  },
  {
    img: MaterialsImg3,
    title: "Double Low-E Glazing",
    text: "Multiple layers of energy-saving glass that reduce heat loss, improve insulation and block outside noise."
  },
  {
    img: MaterialsImg4,
    title: "Warm Edge Spacer",
    text: "An advanced thermal barrier that prevents condensation and increases the overall energy efficiency of the window."
  },
];

const Materials = () => {
  return (
    <div className={styles.container}>
      <div className="customContainer">

        {/* TITLE */}
        <div className={styles.titles}>
          <hr className={styles.titles_line} />
          <h2 className={styles.titles_title}>Materials</h2>
          <hr className={styles.titles_line} />
        </div>

        <p className={styles.subtitle}>
          Our windows are made from certified European materials that ensure long-lasting durability and comfort.
          Every detail, from the profile to the glazing, is designed to optimize performance and aesthetics.
        </p>

        {/* GRID */}
        <div className={styles.grid}>
          {cards.map((item, index) => (
            <div className={styles.card} key={index}>
              <img src={item.img} alt={item.title} className={styles.card_image} />

              <div className={styles.card_titleWrap}>
                <div className={styles.card_line}></div>
                <h3 className={styles.card_title}>{item.title}</h3>
              </div>

              <p className={styles.card_text}>{item.text}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}

export default Materials
